import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Instagram, Linkedin, Twitter } from 'lucide-react';
import logo from '../assets/logo.png';

export default function Footer() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = width <= 767;
  const isTablet = width > 767 && width <= 1024;

  return (
    <footer style={{ background: 'var(--bg2)', borderTop: '1px solid var(--border)', padding: isMobile ? '40px 20px 24px' : '64px 24px 32px' }}>
      <div style={{ maxWidth: '1140px', margin: '0 auto' }}>

        {/* Top row */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : '1.5fr 1fr 1fr 1fr',
          gap: isMobile ? '32px' : isTablet ? '32px' : '48px',
          marginBottom: isMobile ? '32px' : '56px'
        }}>

          {/* Brand */}
          <div>
            <div style={{ marginBottom: '16px' }}>
              <img src={logo} alt="WebWalay" style={{ width: '100px', height: '100px', display: 'block', objectFit: 'contain' }} />
            </div>
            <p style={{ fontSize: '14px', color: 'var(--text2)', lineHeight: 1.75, maxWidth: isMobile ? '100%' : '260px', marginBottom: '24px' }}>
              Pakistan's simplest website subscription. Get a professional website with hosting & maintenance for just Rs. 5,000/month.
            </p>
            <div style={{ display: 'flex', gap: '10px' }}>
              {[
                { icon: <Instagram size={16} />, href: 'https://www.google.com/' },
                { icon: <Linkedin size={16} />, href: 'https://www.google.com/' },
                { icon: <Twitter size={16} />, href: 'https://www.google.com/' },
              ].map((s, i) => (
                <a key={i} href={s.href}
                  style={{ width: '36px', height: '36px', borderRadius: '8px', background: 'var(--bg3)', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text2)', textDecoration: 'none', transition: 'all 0.2s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--lime)'; e.currentTarget.style.color = 'var(--lime-dark)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--text2)'; }}
                >{s.icon}</a>
              ))}
            </div>
          </div>

          {/* Links */}
          {[
            {
              title: 'Company',
              links: [
                { label: 'About Us', to: '/#about' },
                { label: 'Services', to: '/#services' },
                { label: 'Process', to: '/#process' },
                { label: 'Reviews', to: '/#testimonials' },
              ],
            },
            {
              title: 'Product',
              links: [
                { label: 'Pricing', to: '/pricing' },
                { label: 'What\'s Included', to: '/pricing#included' },
                { label: 'FAQ', to: '/pricing#faq' },
                { label: 'Get Started', to: '/pricing' },
              ],
            },
            {
              title: 'Contact',
              links: [
                { label: 'hello@webwalay.pk', href: 'mailto:hello@webwalay.pk', icon: <Mail size={12} /> },
                { label: '+92 300 0000000', href: 'tel:+923000000000', icon: <Phone size={12} /> },
                { label: 'Karachi, Pakistan', href: 'tel:+923000000000' },
              ],
            },
          ].map(col => (
            <div key={col.title}>
              <div style={{ fontFamily: 'Syne,sans-serif', fontSize: '14px', fontWeight: 700, color: 'var(--text)', marginBottom: '16px' }}>{col.title}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {col.links.map(l => (
                  l.href ? (
                    <a key={l.label} href={l.href}
                      style={{ fontSize: '13px', color: 'var(--text2)', textDecoration: 'none', transition: 'color 0.15s', display: 'flex', alignItems: 'center', gap: '6px' }}
                      onMouseEnter={e => e.currentTarget.style.color = 'var(--lime-dark)'}
                      onMouseLeave={e => e.currentTarget.style.color = 'var(--text2)'}
                    >{l.icon}{l.label}</a>
                  ) : (
                    <Link key={l.label} to={l.to}
                      style={{ fontSize: '13px', color: 'var(--text2)', textDecoration: 'none', transition: 'color 0.15s' }}
                      onMouseEnter={e => e.currentTarget.style.color = 'var(--lime-dark)'}
                      onMouseLeave={e => e.currentTarget.style.color = 'var(--text2)'}
                    >{l.label}</Link>
                  )
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div style={{
          display: 'flex',
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: 'space-between',
          paddingTop: '24px',
          borderTop: '1px solid var(--border)',
          flexWrap: 'wrap',
          gap: '12px',
          flexDirection: isMobile ? 'column' : 'row',
        }}>
          <p style={{ fontSize: '13px', color: 'var(--text3)', margin: 0 }}>
            © 2025 WebWalay. All rights reserved. Made with ❤️ in Pakistan.
          </p>
          <div style={{ display: 'flex', gap: isMobile ? '16px' : '20px' }}>
            {['Privacy Policy', 'Terms of Use'].map(t => (
              <a key={t} href="/" style={{ fontSize: '12px', color: 'var(--text3)', textDecoration: 'none', transition: 'color 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.color = 'var(--lime-dark)'}
                onMouseLeave={e => e.currentTarget.style.color = 'var(--text3)'}
              >{t}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
